function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { createMessage } from "../core/createMessage.mjs";
import { isWebView } from "../core/isWebView.mjs";
import { Type } from "../protocol/Type.mjs";
import { PluginBase } from "./Base.mjs";
export class PluginRouter extends PluginBase {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "namespace", 'router');
  }

  push({
    remote,
    app,
    path,
    navbar,
    navbarTitle,
    scrollable,
    enableSafeAreaInsets,
    backSwipable,
    present
  }) {
    if (!isWebView()) {
      return this.logger.log('WARN', 'bridge.router.push', 'WebView 환경이 아닌 환경에서는 해당 함수를 지원하지 않아요');
    }

    this.driver.postMessage(createMessage({
      type: present ? Type.ReqRouterOpen : Type.ReqRouterPush,
      payload: {
        router: {
          remote,
          app,
          path,
          navbar,
          navbarTitle,
          scrollable,
          enableSafeAreaInsets,
          backSwipable
        }
      }
    }));
  }

  close() {
    if (!isWebView()) {
      return this.logger.log('WARN', 'bridge.router.close', 'WebView 환경이 아닌 환경에서는 해당 함수를 지원하지 않아요');
    }

    this.driver.postMessage(createMessage({
      type: Type.ReqRouterClose
    }));
  }

  replace({
    remote,
    app,
    path,
    navbar,
    navbarTitle,
    scrollable,
    enableSafeAreaInsets,
    backSwipable
  }) {
    if (!isWebView()) {
      return this.logger.log('WARN', 'bridge.router.replace', 'WebView 환경이 아닌 환경에서는 해당 함수를 지원하지 않아요');
    }

    this.driver.postMessage(createMessage({
      type: Type.ReqRouterReplace,
      payload: {
        router: {
          remote,
          app,
          path,
          navbar,
          navbarTitle,
          scrollable,
          enableSafeAreaInsets,
          backSwipable
        }
      }
    }));
  }

  prefetch({
    app
  }) {
    if (!isWebView()) {
      return this.logger.log('WARN', 'bridge.router.prefetch', 'WebView 환경이 아닌 환경에서는 해당 함수를 지원하지 않아요');
    }

    this.driver.postMessage(createMessage({
      type: Type.ReqRouterPrefetch,
      payload: {
        router: {
          app
        }
      }
    }));
  }

  style({
    navbar,
    navbarTitle,
    scrollable,
    enableSafeAreaInsets,
    backSwipable,
    forceHeight
  }) {
    if (!isWebView()) {
      return this.logger.log('WARN', 'bridge.router.style', 'WebView 환경이 아닌 환경에서는 해당 함수를 지원하지 않아요');
    }

    this.driver.postMessage(createMessage({
      type: Type.ReqRouterStyle,
      payload: {
        router: {
          navbar,
          navbarTitle,
          scrollable,
          enableSafeAreaInsets,
          backSwipable,
          forceHeight
        }
      }
    }));
  }

  open({
    remote,
    app,
    path,
    navbar,
    navbarTitle,
    scrollable,
    enableSafeAreaInsets,
    backSwipable
  }) {
    this.logger.log('WARN', 'bridge.router.open', '이 API는 deprecated 되었어요. 대신 `bridge.router.push({ present: true })`를 사용하세요.');

    if (!isWebView()) {
      return this.logger.log('WARN', 'bridge.router.open', 'WebView 환경이 아닌 환경에서는 해당 함수를 지원하지 않아요');
    }

    this.driver.postMessage(createMessage({
      type: Type.ReqRouterOpen,
      payload: {
        router: {
          remote,
          app,
          path,
          navbar,
          navbarTitle,
          scrollable,
          enableSafeAreaInsets,
          backSwipable
        }
      }
    }));
  }

  pop() {
    this.logger.log('WARN', 'bridge.router.pop', '이 API는 deprecated 되었어요. 대신 `bridge.router.close()`를 사용하세요.');

    if (!isWebView()) {
      return this.logger.log('WARN', 'bridge.router.pop', 'WebView 환경이 아닌 환경에서는 해당 함수를 지원하지 않아요');
    }

    this.driver.postMessage(createMessage({
      type: Type.ReqRouterPop
    }));
  }

}